// Vendor Views Exports
export { default as VendorCenter } from './views/VendorCenter.vue';
export { default as AddNewVendor } from './views/AddNewVendor.vue';
export { default as EditVendor } from './views/EditVendor.vue';
export { default as VendorServiceItem } from './views/VendorServiceItem.vue';
export { default as VendorProductItem } from './views/VendorProductItem.vue';
export { default as VendorCashPurchase } from './views/VendorCashPurchase.vue';
export { default as VendorCredit } from './views/VendorCredit.vue';
export { default as VendorWriteCheck } from './views/VendorWriteCheck.vue';
export { default as VendorPrintCheck } from './views/VendorPrintCheck.vue';
export { default as EnterBill } from './views/EnterBill.vue';
export { default as CreateBill } from './views/CreateBill.vue';
export { default as DraftBills } from './views/DraftBills.vue';
export { default as VendorCashExpense } from './views/VendorCashExpense.vue';
export { default as VendorCreditCardExpense } from './views/VendorCreditCardExpense.vue';
export { default as VendorsList } from './views/VendorsList.vue';
export { default as VendorItemsList } from './views/VendorItemsList.vue';
export { default as VendorPaymentsList } from './views/VendorPaymentsList.vue';

// Vendor Routes
export const vendorRoutes = [
    {
        path: 'vendors/center',
        name: 'VendorCenter',
        component: () => import('./views/VendorCenter.vue'),
    },
    {
        path: 'vendors/new-vendor',
        name: 'AddNewVendor',
        component: () => import('./views/AddNewVendor.vue'),
    },
    {
        path: 'vendors/edit/:vendorId',
        name: 'EditVendor',
        component: () => import('./views/EditVendor.vue'),
    },
    {
        path: 'vendors/new-service-item',
        name: 'VendorServiceItem',
        component: () => import('./views/VendorServiceItem.vue'),
    },
    {
        path: 'vendors/new-product-item',
        name: 'VendorProductItem',
        component: () => import('./views/VendorProductItem.vue'),
    },
    {
        path: 'vendors/cash-purchase',
        name: 'VendorCashPurchase',
        component: () => import('./views/VendorCashPurchase.vue'),
    },
    {
        path: 'vendors/vendor-credit',
        name: 'VendorCredit',
        component: () => import('./views/VendorCredit.vue'),
    },
    {
        path: 'vendors/write-check',
        name: 'VendorWriteCheck',
        component: () => import('./views/VendorWriteCheck.vue'),
    },
    {
        path: 'vendors/print-check',
        name: 'VendorPrintCheck',
        component: () => import('./views/VendorPrintCheck.vue'),
    },
    {
        path: 'vendors/enter-bill',
        name: 'EnterBill',
        component: () => import('./views/EnterBill.vue'),
    },
    {
        path: 'vendors/create-bill',
        name: 'CreateBill',
        component: () => import('./views/CreateBill.vue'),
    },
    {
        path: 'vendors/draft-bills',
        name: 'DraftBills',
        component: () => import('./views/DraftBills.vue'),
    },
    {
        path: 'vendors/mail-sources',
        name: 'VendorMailSources',
        component: () => import('./views/VendorMailSources.vue'),
    },
    {
        path: 'vendors/pay-bill',
        name: 'PayBill',
        component: () => import('./views/PayBill.vue'),
    },
    {
        path: 'vendors/bills',
        name: 'BillsAndExpensesList',
        component: () => import('./views/BillsAndExpensesList.vue'),
    },
    {
        path: 'vendors/cash-expense',
        name: 'VendorCashExpense',
        component: () => import('./views/VendorCashExpense.vue'),
    },
    {
        path: 'vendors/credit-card-expense',
        name: 'VendorCreditCardExpense',
        component: () => import('./views/VendorCreditCardExpense.vue'),
    },
    {
        path: 'vendors/list',
        name: 'VendorsList',
        component: () => import('./views/VendorsList.vue'),
    },
    {
        path: 'vendors/items',
        name: 'VendorItemsList',
        component: () => import('./views/VendorItemsList.vue'),
    },
    {
        path: 'vendors/payments',
        name: 'VendorPaymentsList',
        component: () => import('./views/VendorPaymentsList.vue'),
    },
    {
        path: 'vendors/portal-hub',
        name: 'VendorPortalHub',
        component: () => import('./views/VendorPortalHub.vue'),
    },
];
